import React from "react";
import ProspectsContent from "../components/prospects/prospects-content";

const Prospects = () => {
  return <ProspectsContent />;
};

export default Prospects;
